<!--
 * @FilePath: App.vue
 * @Author: 孙新宇
 * @Date: 2022-12-27 09:15:51
 * @LastEditTime: 2023-01-04 08:46:00
 * @Descripttion: 
-->
<template>
  <div id="app">
    <!-- 无颜色遮罩层 -->
    <div class="mask" v-if="maskShow"></div>

    <keep-alive :include="cache">
      <router-view />
    </keep-alive>

    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"> </router-view> -->
  </div>
</template>

<script>
import Vue from "vue";
import { Tabbar, TabbarItem, Toast } from "vant";
import * as dd from "dingtalk-jsapi";
import { queryUserInfo } from "./http";
// import { useUserStore } from "./store";

Vue.use(Toast);
Vue.use(Tabbar);
Vue.use(TabbarItem);

export default {
  data() {
    return {
      status: 0,
      cache: "ArticleList",
      maskShow: true,
    };
  },
  methods: {},
  watch: {
    // 返回HOME页时, keep-alive 不缓存
    $route(to, from) {
      if (to.name === "Home" && from.name) {
        this.cache = "";
      }
      // 去ArticleList页时, keep-alive 缓存
      if (to.name === "article") {
        this.cache = "ArticleList";
      }
    },
  },
  mounted() {
    let __this = this;

    dd.ready(function () {
      dd.runtime.permission.requestAuthCode({
        corpId: "ding9a2ea22509cccd63f5bf40eda33b7ba0", // 企业id
        onSuccess: function (info) {
          // 通过该免登授权码可以获取用户身份
          queryUserInfo({ authCode: info.code })
            .catch((err) => {
              Toast("登录失败");
              console.log("queryUserInfo err:", err);
            })
            .finally(() => {
              __this.maskShow = false;
            });
        },
      });
    });
  },
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
.van-dropdown-item__content {
  max-height: 400px !important;
}
.mask {
  position: fixed;
  /* background-color: #ccc; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
}
</style>
